import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

import { apiPaths } from '../../../../../service/apiPaths';
import ApiService from '../../../../../service/ApiService';

interface DocumentData {
  title: string;
  link: string;
  tag: string;
  video: string;
}

const useAddDocument = () => {
  const [documentData, setDocumentData] = useState<DocumentData>({
    title: "",
    link: "",
    tag: "",
    video: ""
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [videoUrl, setVideoUrl] = useState<string>("");
  const navigate = useNavigate();

  const handleInputChange = (field: keyof DocumentData, value: any) => {
    setDocumentData((prev) => ({ ...prev, [field]: value }));
  };

  const handleFileChange = (
    field: "pdfFile" | "videoFile",
    file: File | null
  ) => {
    console.log("File:", file);
    setDocumentData((prev) => ({ ...prev, [field]: file }));
  };
  
  const handleSave = async () => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("title", documentData.title);
      formData.append("link", documentData.link);
      formData.append("tag", documentData.tag);
      formData.append("video", documentData.video);
      const response = await ApiService({
        method: "POST",
        endpoint: apiPaths.createDocument,
        data: formData,
      });
      if (response !== "undefined") {
        toast.success("Document added successfully", {
          duration: 5000,
        });
        navigate('/document')
      }
    } catch (error) {
      toast.error(`Error - ${error}`, {
        duration: 5000,
      });
      console.error("Error adding document:", error);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    documentData,
    handleInputChange,
    handleFileChange,
    handleSave,
  };
};

export default useAddDocument;
